import { useContext } from 'react';
import { ReferenceContext } from 'context/reference';

const useReferenceContext = () => {
  return useContext(ReferenceContext);
};

export default useReferenceContext;
